import { Link } from "react-router-dom";
import { Instagram, ArrowUpRight, Phone, Mail } from "lucide-react";
import { CONTACT, NAV } from "@/lib/data";
import { Reveal } from "@/components/Reveal";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="noise relative overflow-hidden bg-ink text-white">
      <div className="pointer-events-none absolute -right-40 -top-40 h-[520px] w-[520px] rounded-full bg-grad opacity-20 blur-[130px]" />
      <div className="relative mx-auto max-w-[1440px] px-6 py-20 md:px-12 md:py-28">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-end lg:justify-between">
          <Reveal>
            <p className="mb-4 text-sm uppercase tracking-[0.25em] text-white/50">Vamos começar</p>
            <h2 className="font-display text-5xl font-extrabold leading-[0.92] tracking-tight sm:text-7xl lg:text-8xl">
              Get your business <span className="text-grad">visible.</span>
            </h2>
          </Reveal>
          <Reveal delay={1}>
            <Link
              to="/contacto"
              data-testid="footer-cta"
              className="group inline-flex items-center gap-3 rounded-full bg-grad px-8 py-5 text-lg font-medium text-white shadow-[0_20px_50px_-15px_rgba(79,111,214,0.7)] transition-transform duration-300 hover:-translate-y-0.5"
            >
              Fale connosco
              <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-20 grid grid-cols-2 gap-10 border-t border-white/10 pt-12 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <img src="/brand/logo-light.png" alt="Logótipo Get Visible" className="h-8 w-auto" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/55">
              Criamos websites modernos, rápidos e à medida — feitos para dar visibilidade ao seu negócio.
            </p>
          </div>

          <nav aria-label="Navegação do rodapé">
            <p className="mb-4 text-xs uppercase tracking-[0.2em] text-white/40">Navegação</p>
            <ul className="space-y-2.5">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="link-underline text-sm text-white/75 hover:text-white">{n.label}</Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <p className="mb-4 text-xs uppercase tracking-[0.2em] text-white/40">Contacto</p>
            <ul className="space-y-3 text-sm text-white/75">
              <li><a href={CONTACT.phoneHref} data-testid="footer-phone" className="inline-flex items-center gap-2 hover:text-white"><Phone className="h-4 w-4 text-brightblue" /> {CONTACT.phone}</a></li>
              <li>
               <a
                 href={CONTACT.emailHref}
                 data-testid="footer-email"
                 className="inline-flex min-w-0 items-start gap-2 hover:text-white"
               >
                 <Mail className="mt-0.5 h-4 w-4 shrink-0 text-brightblue" />
                 <span className="break-all sm:break-normal">{CONTACT.email}</span>
               </a>
              </li>
              <li><a href={CONTACT.instagramHref} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="inline-flex items-center gap-2 hover:text-white"><Instagram className="h-4 w-4 text-brightblue" /> {CONTACT.instagram}</a></li>
            </ul>
          </div>

          <div>
            <p className="mb-4 text-xs uppercase tracking-[0.2em] text-white/40">Legal</p>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/politica-de-privacidade" className="link-underline text-white/75 hover:text-white">Política de Privacidade</Link></li>
              <li><Link to="/politica-de-cookies" className="link-underline text-white/75 hover:text-white">Política de Cookies</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-white/10 pt-8 text-xs text-white/45 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} Get Visible. Todos os direitos reservados.</p>
          <p>Websites à medida, feitos em {CONTACT.location}.</p>
        </div>
      </div>
    </footer>
  );
};
